var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change__form",staticStyle:{"padding":"0"}},[_c('AppInput',_vm._b({attrs:{"rules":"required"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'AppInput',{
        bg: '#272c35',
        label: _vm.form.placeholder
      },false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fada564","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Modals/Form.vue
// module id = null
// module chunks = 